import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting/shipping-costs";

export default {
  getShippingCost(id) {
    return Repository.get(`${resource}/${id}`)
  },
  getShippingCostList(pageNumber = 1, filterQuery = '', pagination = defaultPagination, sort = '', is_paginate = 0) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}&is_paginate=${is_paginate}`)
  },
  createShippingCost(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteShippingCost(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateShippingCost(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
